import React from 'react';
import { useTranslation } from 'react-i18next';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import './mobile-toggle.scss';

export default ({ isMobile, setIsMobile }) => {
  const { t } = useTranslation('app');
  function getChecked() {
    if (typeof isMobile === 'boolean') {
      return isMobile;
    } else {
      return isMobile === 'true';
    }
  }
  return (
    <Toggle
      className="mobile-toggle"
      checked={getChecked()}
      onChange={({ target }) => {
        localStorage.setItem('isMobile', target.checked ? 'true' : 'false');
        setIsMobile(target.checked);
      }}
      icons={{
        checked: (
          <span title={t('Mobile')} className="md-icon dark-mode-icon">
            smartphone
          </span>
        ),
        unchecked: (
          <span title={t('Desktop')} className="md-icon light-mode-icon">
            laptop
          </span>
        ),
      }}
      aria-label="Dark mode toggle"
    />
  );
};
